export const AUTH_TOKEN_COOKIE_NAME = 'lkAccessToken';
export const AUTH_TOKEN_DEALER_COOKIE_NAME = 'lkDealerAccessToken';
export const LK_ROOT_ELEMENT_ID = 'lkRootElement';
export const CART_ROOT_ELEMENT_ID = 'cartRootElement';
export const USER_HEADER_PROFILE_ROOT_ELEMENT_ID = 'userHeaderProfileElement';
